export default __webpack_public_path__ + "static/media/ic-cultivation-3.c77f6157.svg";